export const MIN_BOUNDS_PADDING = 8;
export const DEFAULT_WORKWEEKDAYS = 127; // Bit mask of 2^7
export const DEFAULT_PANEL_MARGIN_RIGHT = 17;
